import React, { useEffect, useState } from "react";

import { motion } from "framer-motion";

type TransitionContainerProps = {
  children?: any;
  transitionTrigger: string;
  initiallyVisible?: boolean;
  duration?: number;
  style?: React.CSSProperties;
};

const TransitionContainer = ({
  children,
  transitionTrigger,
  initiallyVisible = true,
  duration = 0.5,
  style = {},
}: TransitionContainerProps) => {
  const variants = {
    hidden: { opacity: 0, scale: 0, transition: { duration: duration } },
    visible: { opacity: 1, scale: 1, transition: { duration: duration } },
  };
  const [isFirstRender, setIsFirstRender] = useState(true);
  const [isVisible, setIsVisible] = useState(false);
  const [updatedChildren, setUpdatedChildren] = useState(children);
  useEffect(() => {
    if (isFirstRender) {
      setIsFirstRender(false);
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [transitionTrigger]);
  useEffect(() => {
    const delayChildrenUpdate = async () => {
      if (isVisible && !isFirstRender) {
        await new Promise((resolve) => setTimeout(resolve, 500));
        setUpdatedChildren(children);
      }
    };
    delayChildrenUpdate();
  }, [children, isVisible, isFirstRender]);
  return (
    <motion.div
      variants={variants}
      initial={initiallyVisible ? "visible" : "hidden"}
      animate={isVisible ? "visible" : "hidden"}
      onAnimationComplete={async () => {
        setUpdatedChildren(children);
        !isVisible && setIsVisible(!isVisible);
      }}
      style={style}
    >
      {updatedChildren}
    </motion.div>
  );
};

export default TransitionContainer;
